import SectorsHero from "./SectorsHero";

export default SectorsHero;